import {
  AnalyticsConfiguration,
  interactionWithServiceAvailCheck,
  notificationEvent,
  notificationEventWithMiscEvents,
  pageViewAndError,
  pageViewEvent,
  selfServeCompleteWithPageViewEvents,
  selfServeSearchClickEvent,
  selfServeStartWithPageViewEvents,
  serviceAvailCheckEvent,
} from '@rci/self-serve-fido/core/analytics';

const pageName = 'transfer phone number';
const baseHierarchy = ['myrogers', pageName];

const step1Name = 'step 1 - check number eligibility';
const step2Name = 'step 2 - service provider details';
const step3Name = 'step 3 - review';
const step4Name = 'step 4 - confirmation';

const page = {
  name: pageName,
  hierarchy: baseHierarchy,
};

const portInPage = {
  name: step1Name,
  hierarchy: baseHierarchy,
};

const portInStep2 = {
  name: step2Name,
  hierarchy: baseHierarchy,
};

const portInStep3 = {
  name: step3Name,
  hierarchy: baseHierarchy,
};

const portInStep4 = {
  name: step4Name,
  hierarchy: baseHierarchy,
};

const genericError = {
  name: 'modal-generic error',
  hierarchy: baseHierarchy,
};

const transferExistingNumber = 'transfer existing number - check eligibility';

export const portInConfiguration: AnalyticsConfiguration = {
  mappings: {
    portInPageOnLoad: {
      page,
      events: pageViewEvent,
    },
    portInOnGoingRequestAlert: {
      page,
      events: notificationEventWithMiscEvents,
    },
    portInLOSAlert: {
      page,
      events: notificationEvent,
    },
    step1Available: {
      page: portInPage,
      events: selfServeStartWithPageViewEvents,
      selfServe: {
        type: 'transaction',
        name: 'actv-myaccount-transfer existing number',
      },
    },
    step1CheckEligibilityCTA: {
      page: portInPage,
      events: interactionWithServiceAvailCheck,
      interaction: {
        type: 'click',
        name: 'Check eligibility',
      },
      service: {
        type: transferExistingNumber,
        availability: 'open',
        id: '',
        postalCode: '',
      },
    },
    step1RequiredFormError: {
      page: portInPage,
    },
    step1IneligibleAPIError: {
      page: portInPage,
      events: serviceAvailCheckEvent,
      service: {
        type: transferExistingNumber,
        availability: 'unavailable',
        id: '',
        postalCode: '',
      },
    },
    genericPortInError: {
      page: genericError,
      events: pageViewAndError,
    },
    step1EligibleAPISuccessResponse: {
      page: portInPage,
      events: serviceAvailCheckEvent,
      service: {
        type: transferExistingNumber,
        availability: 'available',
        id: '',
        postalCode: '',
      },
    },
    step1ContinueCTA: {
      page: portInStep2,
      events: pageViewEvent,
    },
    step2MandatoryFieldError: {
      page: portInStep2,
    },
    step2APIValidationError: {
      page: portInStep2,
    },
    step2ServiceAddressDropdownSelect: {
      page: portInStep2,
      events: selfServeSearchClickEvent,
      search: {
        type: 'find service address',
        keyword: 'service address',
      },
    },
    step2ContinueCTA: {
      page: portInStep3,
      events: pageViewEvent,
    },
    step3SubmitCTA: {
      page: portInStep4,
      events: selfServeCompleteWithPageViewEvents,
      selfServe: {
        type: 'transaction',
        name: 'actv-myaccount-transfer existing number',
      },
    },
    step3MandatoryFieldError: {
      page: portInStep3,
    },
    step3PortInSubmitError: {
      page: portInStep3,
      events: pageViewEvent,
    },
  },
};
